var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconaXFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20.01001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2b2a28;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.25,15.67A2.48421,2.48421,0,0,1,20,17.46a2.72711,2.72711,0,0,1-.03.41016A2.52639,2.52639,0,0,1,17.89,19.97a2.02223,2.02223,0,0,1-.43.04,2.525,2.525,0,0,1-1.79-.75L10,13.59009,4.34,19.26a2.58019,2.58019,0,0,1-1.8.75A2.53849,2.53849,0,0,1,.75,15.67l5.67-5.66L.75,4.34009A2.53529,2.53529,0,0,1,0,2.54,2.49512,2.49512,0,0,1,.75.75a2.59763,2.59763,0,0,1,3.59,0l5.67,5.67L15.67.75A2.525,2.525,0,0,1,17.46,0a2.02223,2.02223,0,0,1,.43.04,2.5269,2.5269,0,0,1,2.08,2.09009A2.7225,2.7225,0,0,1,20,2.54a2.50735,2.50735,0,0,1-.75,1.80005L13.59,10Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaXFill);
export default __webpack_public_path__ + "static/media/iconaXFill.e9d61b161d07f0a90b62d044c5767023.svg";
export { ForwardRef as ReactComponent };